module.exports = __webpack_public_path__ + "img/login_left_img.299eb658.png";